export const unansweredInformation = 'unansweredInformation'
export const answeredInformation = 'answeredInformation'
export const beforeLoginInformation = 'beforeLoginInformation'
export const isUnansweredListView = 'isUnansweredListView'
export const isLogin = 'isLogin'
export const resultCorrectInformation = 'resultCorrectInformation'
export const resultIncorrectInformation = 'resultIncorrectInformation'
export const pageNumber = 'pageNumber'
export const maxPageNumber = 'maxPageNumber'
export const point = 'point'
export const isLoadingWait = 'isLoadingWait'
export const isSetUp = 'isSetUp'
